module.exports = new __parcel__URL__("svi-housing--dataset-cover.5f46fb37.png").toString();